import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { MdDialogRef, MD_DIALOG_DATA, DateAdapter } from "@angular/material";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";

import { ItemTypeManagerComponent } from "../item-type-manager/item-type-manager.component";
import { RuoloBloccoManagerComponent } from "./ruolo-blocco-manager/ruolo-blocco-manager.component";
import { MetadataBloccoComponent } from "./metadata-blocco/metadata-blocco.component";
import { ImagesBloccoComponent } from "./images-blocco/images-blocco.component";

import { DashboardService } from "../../../services/dashboard.service";
import { SharedService } from "../../../services/shared.service";

import { BloccoModel } from "../../../models/dashboard/blocco.model";
import { SliderModel } from "../../../models/dashboard/slider.model";
import { SaveBloccoModel } from "../../../models/dashboard/saveBlocco.model";

import * as _ from "lodash";
import { BloccoTipoModel } from "../../../models/dashboard/bloccoTipo.model";
import { HttpMetadataBloccoComponent } from "./http-metadata-blocco/http-metadata-blocco.component";
import { DownloadExternalSourceBloccoComponent } from "./download-external-source-blocco/download-external-source-blocco.component";
import { Configurations } from "../../../core/configurations";
import { BusinessLineBloccoManagerComponent } from "./business-line-blocco-manager/business-line-blocco-manager.component";

@Component({
  selector: "app-item-manager",
  templateUrl: "./item-manager.component.html",
  styleUrls: ["./item-manager.component.css"],
})
export class ItemManagerComponent implements OnInit {
  mode: string;
  blocco: BloccoModel;
  form: FormGroup;

  idBlocco: number;
  tipi: Array<BloccoTipoModel> = [];

  currentSlider: SliderModel;

  loading: boolean = false;

  currentStep = "type";

  steps = {
    type: "type",
    images: "images",
    metadata: "metadata",
    httpMetadata: "httpMetadata",
    downloadExternalSource: "downloadExternalSource",
    roles: "roles",
    businessLines: "businessLines"
  };

  title = "Inserimento nuovo blocco";

  @ViewChild("formTypeComponent") formTypeComponent: ItemTypeManagerComponent;
  @ViewChild("formRuoloBloccoComponent")
  formRuoloBloccoComponent: RuoloBloccoManagerComponent;
  @ViewChild("formBusinessLineBloccoComponent")
  formBusinessLineBloccoComponent: BusinessLineBloccoManagerComponent;
  @ViewChild("formImagesBloccoComponent")
  formImagesBloccoComponent: ImagesBloccoComponent;
  @ViewChild("formMetadataBloccoComponent")
  formMetadataBloccoComponent: MetadataBloccoComponent;
  @ViewChild("formHttpMetadataBloccoComponent")
  formHttpMetadataBloccoComponent: HttpMetadataBloccoComponent;
  @ViewChild("formDownloadExternalSourceBloccoComponent")
  formDownloadExternalSourceBloccoComponent: DownloadExternalSourceBloccoComponent;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MdDialogRef<ItemManagerComponent>,
    private _dashboardService: DashboardService,
    private _sharedService: SharedService,
    private _dateAdapter: DateAdapter<Date>,
    private configurations: Configurations,
    @Inject(MD_DIALOG_DATA) data
  ) {
    if (data) {
      this.mode = "edit";
      this.title = "Modifica blocco";
      this.blocco = data;
    }
    this._dateAdapter.setLocale("it-IT");
  }

  ngOnInit() {
    this.currentSlider = this._sharedService.getSlider();
    this.createForm(this.formBuilder);
    this.tipi = this._sharedService.getTipi();
    this.setFormValues();
    initDatePicker();
  }

  closeDialogRef(itemsToReturn?: any) {
    this.dialogRef.close(itemsToReturn);
  }

  createForm(fb: FormBuilder) {
    this.form = fb.group({
      cols: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(100),
        ])
      ),
      rows: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(1000),
        ])
      ),
      order: new FormControl(
        this.currentSlider.blocchiInfo.length,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(this.currentSlider.blocchiInfo.length - 1),
        ])
      ),
      type: new FormControl("", Validators.required),
      name: new FormControl("", Validators.required),
      titolo: new FormControl("", Validators.required),
      sottotitolo: new FormControl(""),
      pubblicato: new FormControl(false),
      dataInizio: new FormControl(null),
      dataFine: new FormControl(null),
    });
  }

  gotoImagesOrRolesStage() {
    /*
      create the block and pass further to the next stage
      go to the images stage if is an IMG or a DOWNLOAD
      OR go to the roles
    */
    this.loading = true;
    const blocco: SaveBloccoModel = {
      tipo: {
        id: 0,
        codice: this.type().value,
      },
      colonneBlocco: this.cols().value,
      righeBlocco: this.rows().value,
      nomeBlocco: this.name().value,
      titolo: this.titolo().value,
      sottotitolo: this.sottotitolo().value,
      dataInizio: this.dataInizio().value,
      dataFine: this.dataFine().value,
      pubblicato: this.pubblicato().value,
      codiceBloccoTipo: this.type().value,
      programmaTipo: {
        codice: "CQOIL",
      },
      ...this.formTypeComponent.form.value,
    };

    if (this.blocco) {
      const tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
      const localISOTime = (date) =>
        new Date(date - tzoffset).toISOString().slice(0, -1);
      const bloccoSupport = {
        ...this.blocco,
        nomeBlocco: this.name().value,
        titolo: this.titolo().value,
        sottotitolo: this.sottotitolo().value,
        righeBlocco: this.rows().value,
        colonneBlocco: this.cols().value,
        dataInizio: this.dataInizio().value
          ? localISOTime(this.dataInizio().value)
          : null,
        dataFine: this.dataFine().value
          ? localISOTime(this.dataFine().value)
          : null,
        pubblicato: this.pubblicato().value,
        ...this.formTypeComponent.form.value,
      };
      if (!_.isEqual(this.blocco, bloccoSupport)) {
        // update
        /*
        for (let [key, value] of Object.entries(this.blocco)) {
          if (!_.isEqual(value, bloccoSupport[key])) {
            console.log(`${key}: ${value}`);
            console.log(`${value}`);
            console.log(bloccoSupport[key]);
          }
        }
         */

        this.updateBlocco(bloccoSupport);
      } else {
        this.setViewAfterBlocco(bloccoSupport);
      }
    } else {
      this.addBlocco(blocco);
    }
  }

  private updateBlocco(blocco: SaveBloccoModel) {
    this._dashboardService
      .updateBlocco({
        ...blocco,
        id: this.blocco.idBlocco,
        token: this.blocco.token,
      })
      .subscribe(
        (res: BloccoModel) => {
          this.setViewAfterBlocco(blocco, res);
        },
        (err) => {
          this.loading = false;
        }
      );
  }

  private addBlocco(blocco: SaveBloccoModel) {
    const item = {
      ...blocco,
    };
    if (blocco.codiceBloccoTipo === "IMG") {
      item.descrizione = "";
    }
    this._dashboardService.addBlocco(item).subscribe(
      (res: BloccoModel) => {
        // addBloccoToSlider
        this.setViewAfterBlocco(blocco, res);
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  gotoRolesStage() {
    /*
      we alredy created or update the block
      so now we have to associate the images or the file
      and THEN go to the roles stage
    */
    this.currentStep = this.steps.roles;
  }

  goToBusinessLines() {
  /*
      we alredy created or update the block
      we set roles
      and THEN go to the business lines stage
    */
   this.currentStep = this.steps.businessLines;
    
  }

  updateMetadata() {
    this.currentStep = this.steps.roles;
  }

  updateHttpMetadata() {
    let json = this.formHttpMetadataBloccoComponent.json;
    if (json && !json.startsWith("{")) {
      json = `{${json}}`;
    }
    const blocco = this._sharedService.getBlocco();
    this._dashboardService
      .updateBlocco({
        ...blocco,
        json: json,
      })
      .subscribe(
        (res: BloccoModel) => {
          this.currentStep = this.steps.roles;
        },
        (err) => {}
      );
  }

  updateDownloadExternalSource() {
    const taxonomyValue = this.formDownloadExternalSourceBloccoComponent.form.get(
      "taxonomy"
    ).value;
    const idBloccoDownloadExternalSourceItemTaxonomyTipo = this.configurations
      .getSubfolderTaxonomyTipo;
    const idBloccoDownloadExternalSource = this
      .formDownloadExternalSourceBloccoComponent.blocco.id;
    const taxonomy = this.formDownloadExternalSourceBloccoComponent.taxonomy;
    const body = {
      idBloccoDownloadExternalSource,
      idBloccoDownloadExternalSourceItemTaxonomyTipo,
      taxonomyValue,
    };
    if (taxonomy) {
      if (taxonomy.taxonomyValue !== taxonomyValue) {
        this._dashboardService
          .updateTaxonomy({ ...taxonomy, taxonomyValue })
          .subscribe((res) => {
            this.currentStep = this.steps.roles;
          });
      } else {
        this.currentStep = this.steps.roles;
      }
    } else {
      this._dashboardService.saveTaxonomy(body).subscribe((res) => {
        this.currentStep = this.steps.roles;
      });
    }
  }

  saveAndUpdate() {
    /*
      we finished the operation, we've created the block
      associated or not the images and then we close the dialog
    */
    const bloccoToSlider = {
      idBlocco: this.idBlocco,
      idSlider: this.currentSlider.id,
      ordineBlocco: this.currentSlider.blocchiInfo.length,
      dataInizio: new Date().toISOString(),
    };

    this._dashboardService
      .addBloccoToSlider(bloccoToSlider)
      .subscribe((sliderRes) => {
        this.closeDialogRef({
          updateSlider: true,
          idBlocco: this.idBlocco,
          order: this.order().value,
        });
      });
  }

  save() {
    /*
      we finished the operation, we've created the block
      associated or not the images and then we close the dialog
    */
    this.closeDialogRef({
      updateSlider: false,
      idBlocco: this.idBlocco,
      order: this.order().value,
    });
  }

  private setViewAfterBlocco(blocco, res?: any) {
    blocco.codiceBloccoTipo = blocco.codiceBloccoTipo
      ? blocco.codiceBloccoTipo
      : blocco.tipoBlocco;
    this.idBlocco = res ? res.id : blocco.id;
    this.formRuoloBloccoComponent.idBlocco = res ? res.id : blocco.id;
    this.formBusinessLineBloccoComponent.idBlocco = res ? res.id : blocco.id;
    this._sharedService.setBlocco({
      ...blocco,
      ...(res ? res : new SaveBloccoModel()),
      blocchiIFRAMEUserDefined: blocco.blocchiIFRAMEUserDefined,
      blocchiToDOWNLOAD: blocco.blocchiToDOWNLOAD,
    });
    this.formRuoloBloccoComponent.createArrayForView(
      blocco.authManItems && blocco.authManItems.length
        ? blocco.authManItems
        : []
    );
    this.formBusinessLineBloccoComponent.createArrayForView(
      blocco.businessLines && blocco.businessLines.length
        ? blocco.businessLines
        : []
    );
    if (
      blocco.codiceBloccoTipo &&
      (blocco.codiceBloccoTipo === "IMG" ||
        blocco.codiceBloccoTipo === "DOWNLOAD")
    ) {
      this.formImagesBloccoComponent.inizializeForm();
      this.currentStep = this.steps.images;
    } else if (
      blocco.codiceBloccoTipo &&
      blocco.codiceBloccoTipo === "IFRAME"
    ) {
      this.formMetadataBloccoComponent.inizializeForm();
      this.currentStep = this.steps.metadata;
    } else if (blocco.codiceBloccoTipo && blocco.codiceBloccoTipo === "LINK") {
      this.formMetadataBloccoComponent.inizializeForm();
      this.currentStep = this.steps.metadata;
    } else if (
      blocco.codiceBloccoTipo &&
      blocco.codiceBloccoTipo === "HTTP_Data"
    ) {
      this.formHttpMetadataBloccoComponent.inizializeForm();
      this.currentStep = this.steps.httpMetadata;
    } else if (
      blocco.codiceBloccoTipo &&
      blocco.codiceBloccoTipo === "DownloadExternalSource"
    ) {
      this.formDownloadExternalSourceBloccoComponent.inizializeForm();
      this.currentStep = this.steps.downloadExternalSource;
    } else {
      this.currentStep = this.steps.roles;
    }
    this.loading = false;
  }

  setFormValues() {
    const size = this.currentSlider.colonneSlider;
    this.cols().setValidators(
      Validators.compose([
        Validators.required,
        Validators.min(1),
        Validators.max(size),
      ])
    );
    if (this.blocco) {
      this.type().disable();
    } else {
      this.order().disable();
    }
    //TODO find a better condition
    if (
      this.blocco &&
      this.blocco["sliders"] &&
      this.blocco["sliders"].length === 0
    ) {
      this.order().disable();
    }

    // set dei valori nel form se sono in modifica

    if (this.blocco && this.blocco.idBlocco) {
      this.cols().setValue(this.blocco.colonneBlocco);
      this.cols().markAsDirty();
      this.rows().setValue(this.blocco.righeBlocco);
      this.rows().markAsDirty();
      this.order().setValue(this.blocco.ordine);
      this.order().markAsDirty();
      this.name().setValue(this.blocco.nomeBlocco);
      this.name().markAsDirty();
      this.titolo().setValue(this.blocco.titolo);
      this.sottotitolo().setValue(this.blocco.sottotitolo);
      // set del tipo e set dei valori nei form del tipo
      this.type().setValue(this.blocco.tipoBlocco);
      this.pubblicato().setValue(this.blocco.pubblicato);
      this.dataInizio().setValue(
        this.blocco.dataInizio ? new Date(this.blocco.dataInizio) : null
      );
      this.dataFine().setValue(
        this.blocco.dataFine ? new Date(this.blocco.dataFine) : null
      );

      this.changeTypeOption();

      if (this.blocco.authManItems) {
        this.formRuoloBloccoComponent.setRuolo(this.blocco.authManItems);
      }

      if (this.blocco.businessLines) {
        this.formBusinessLineBloccoComponent.setRuolo(this.blocco.businessLines);
      }
    }
  }

  changeTypeOption() {
    this.formTypeComponent.resetFormGroup(
      this.type().value ? this.type().value : "",
      this.blocco
    );
  }

  rows = () => this.form.get("rows");
  cols = () => this.form.get("cols");
  type = () => this.form.get("type");
  name = () => this.form.get("name");
  titolo = () => this.form.get("titolo");
  sottotitolo = () => this.form.get("sottotitolo");
  order = () => this.form.get("order");
  pubblicato = () => this.form.get("pubblicato");
  dataInizio = () => this.form.get("dataInizio");
  dataFine = () => this.form.get("dataFine");
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-manager/item-manager.component.ts